export default "__VITE_ASSET__4726e589__"